import { SalaryStats } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'
import { renderValues } from '../../libs/helpers/reportUtils'

interface IProps {
  statsData: SalaryStats
  type: 'reported' | 'salaryBrackets'
  seniority: 'junior' | 'medium' | 'senior' | 'all'
}
const SalaryTableRow = ({ statsData, type, seniority }: IProps) => {
  const { t, lang } = useTranslation('it_report')
  const itemData = statsData?.[type]?.[seniority]
  if (!itemData) return null

  const employmentData = itemData?.employment
  const b2bData = itemData.b2b

  if (!employmentData && !b2bData) return null

  return (
    <tr className='hover:bg-gray-350 transition-all'>
      <td className='text-center p-2 md:p-4'>{`${t(`salary-${seniority}`)} ${
        statsData.position
      }`}</td>
      {employmentData ? (
        <td className='text-center p-2 md:p-4'>
          {renderValues(employmentData.value, lang)}
        </td>
      ) : (
        <td className='text-center p-2 md:p-4'>-</td>
      )}
      {b2bData ? (
        <td className='text-center p-2 md:p-4'>
          {renderValues(b2bData.value, lang)}
        </td>
      ) : (
        <td className='text-center p-2 md:p-4'>-</td>
      )}
    </tr>
  )
}

export default SalaryTableRow
